var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9547 22.3547L19.4685 24.8685L15.0685 29.2685L12.5547 26.7538L16.9547 22.3547Z",
    fill: "#9AAAB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06947 30.7254L11.2961 25.4996C11.6295 25.1663 12.0816 24.9791 12.553 24.9791C13.0244 24.9791 13.4765 25.1663 13.8099 25.4996L16.3237 28.0134C16.657 28.3467 16.8442 28.7988 16.8442 29.2702C16.8442 29.7416 16.657 30.1937 16.3237 30.5271L11.0979 35.7529C10.7692 36.0892 10.377 36.3569 9.94402 36.5405C9.51109 36.7242 9.04603 36.8201 8.57576 36.8228C8.1055 36.8254 7.63938 36.7348 7.20439 36.5561C6.7694 36.3774 6.37418 36.1141 6.04162 35.7816C5.70906 35.4491 5.44576 35.054 5.26698 34.619C5.08819 34.1841 4.99746 33.7179 5.00005 33.2477C5.00264 32.7774 5.0985 32.3123 5.28206 31.8794C5.46563 31.4464 5.73326 31.0542 6.06947 30.7254Z",
    fill: "#66757F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8232 29C31.4507 29 36.8232 23.6274 36.8232 17C36.8232 10.3726 31.4507 5 24.8232 5C18.1958 5 12.8232 10.3726 12.8232 17C12.8232 23.6274 18.1958 29 24.8232 29Z",
    fill: "#8899A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8234 25.4445C29.4871 25.4445 33.2678 21.6638 33.2678 17C33.2678 12.3363 29.4871 8.55557 24.8234 8.55557C20.1596 8.55557 16.3789 12.3363 16.3789 17C16.3789 21.6638 20.1596 25.4445 24.8234 25.4445Z",
    fill: "#BBDDF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.ff7ec1116c533337f6995d45be1e1e77.svg";
export { ForwardRef as ReactComponent };